import { SET_STATUS_FILTER, SET_COLUMN_FILTERS, RESET_COLUMN_FILTERS } from "../../actions/actionTypes";

const initialState = {
  status: {},   // dynamic based on screen
  columnFilters: {}
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATUS_FILTER:
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload.screen]: action.payload.data
        }
      };

    //Column filter
    case SET_COLUMN_FILTERS: {
      const { screen, columnKey, options } = action.payload;
      const currentScreenFilters = state.columnFilters?.[screen] || {};
      return {
        ...state,
        columnFilters: {
          ...state.columnFilters,
          [screen]: {
            ...currentScreenFilters,
            [columnKey]: options || []
          }
        }
      };
    }

    case RESET_COLUMN_FILTERS: {
      const { screen } = action.payload;
      const updatedFilters = { ...state.columnFilters };
      delete updatedFilters[screen];
      return {
        ...state,
        columnFilters: updatedFilters
      };
    }

    default:
      return state;
  }
};

export default filtersReducer;